import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { ValueStack } from './components/ValueStack';
import { TargetAudience } from './components/TargetAudience';
import { FaqSection } from './components/FaqSection';
import { Testimonials } from './components/Testimonials';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-accent selection:text-forest-dark" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <ValueStack data-id="element-6" />
        <TargetAudience data-id="element-7" />
        <FaqSection data-id="element-8" />
        <Testimonials data-id="element-9" />
        <CtaSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}